// src/pages/admin/billing/AdminBillingHome.js
import React from 'react';
import AdminLayout from '../../../components/admin/AdminLayout';
import { Link } from 'react-router-dom';

function AdminBillingHome() {
  return (
    <AdminLayout title="">
      <h1 style={{ marginTop: 0 }}>Facturation</h1>
      <p>Accédez rapidement à vos modules de facturation.</p>
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(220px,1fr))', gap: 16, marginTop: 16 }}>
        <div className="card">
          <h3>Clients</h3>
          <p>Gérer vos clients.</p>
          <Link to="/admin/facturation/clients">Ouvrir</Link>
        </div>
        <div className="card">
          <h3>Devis</h3>
          <p>Créer et suivre vos devis.</p>
          <Link to="/admin/facturation/devis">Ouvrir</Link>
        </div>
        <div className="card">
          <h3>Factures</h3>
          <p>Émettre et gérer vos factures.</p>
          <Link to="/admin/facturation/factures">Ouvrir</Link>
        </div>
        <div className="card">
          <h3>Contrats</h3>
          <p>Consulter les contrats signés.</p>
          <Link to="/admin/facturation/contrats">Ouvrir</Link>
        </div>
        <div className="card">
          <h3>Prestations</h3>
          <p>Gestion des prestations/services.</p>
          <Link to="/admin/facturation/prestations">Ouvrir</Link>
        </div>
        <div className="card">
          <h3>Stock</h3>
          <p>Gestion des stocks.</p>
          <Link to="/admin/facturation/stock">Ouvrir</Link>
        </div>
        <div className="card">
          <h3>Rendez-vous</h3>
          <p>Planifier et suivre les RDV.</p>
          <Link to="/admin/facturation/rendez-vous">Ouvrir</Link>
        </div>
        <div className="card">
          <h3>Historique</h3>
          <p>Voir l'historique des opérations.</p>
          <Link to="/admin/facturation/historique">Ouvrir</Link>
        </div>
        <div className="card">
          <h3>Paramètres</h3>
          <p>Configurer numérotation, TVA, PDF…</p>
          <Link to="/admin/facturation/parametres">Ouvrir</Link>
        </div>
      </div>
    </AdminLayout>
  );
}

export default AdminBillingHome;
